import React from "react";

import Button, { ButtonColor } from "components/shared/button";

import { useStoresWithManageableUserPermission } from "pos_users/hooks/useStoresWithManageableUserPermission";

export const CreateUserButton = () => {
  const availableStores = useStoresWithManageableUserPermission();
  if (!availableStores?.length) {
    return null;
  }
  const store = availableStores[0];
  return (
    <Button
      label="Create User"
      linkPath={`/s/${store.id}/users/create`}
      buttonColor={ButtonColor.BLUE}
    />
  );
};
